<mat-sidenav-container class="mt-4 example-container">
  <mat-sidenav #sidenav class="example-sidenav bg-slate-100" mode="over" position="end">
    <div class="ps-2 ms-2 d-flex flex-column">
      <app-filtro-elenco-risorse
        [attore]="attore" [uoPrimoLivello]="uoPrimoLivello"
        (searchEvent)="search($event)"></app-filtro-elenco-risorse>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="example-content">
    @if ([attori.ControllerCentrale].includes(attore)) {
    <div class="row mt-1 mb-1">
      <div class="col-12 d-flex justify-content-end pe-4">
        <h5 class="fw-bold">
          Numero celle coincidenti: {{ conteggioCoincidenze }}
        </h5>
      </div>
    </div>
    }
    <div class="rounded bg-white shadow-sm mt-2 mb-4 pb-3 pt-4 px-4 w-100">
      <div class="row g-3 mb-3">
        <h5 class="fw-bold">Elenco delle risorse</h5>
        <div class="col-4">
          <button type="button" class="btn btn-outline-primary fw-semibold" title="Filtra" (click)="sidenav.toggle()">
            <i class="bi bi-funnel-fill me-1"></i>
            Filtra
          </button>
          @if (elencoRisorse.length > 0) {
          <button (click)="exportDataToExcel()" type="button" class="btn btn-outline-primary ms-3 fw-semibold">
            <i class="bi bi-file-earmark-spreadsheet-fill me-1"></i>
            Esporta in Excel
          </button>
          }
        </div>
        <div class="col-8 d-flex justify-content-end">
          @if ([attori.ControllerCentrale].includes(attore)) {
          <button type="button" class="btn btn-outline-primary fw-semibold me-3" (click)="goToStoricoDeleghe()">
            <i class="bi bi-people-fill me-1"></i>
            Gestione deleghe
          </button>
          }
          <button type="button" class="btn fw-semibold"
            (click)="goToRiepilogoModifiche()"
            [ngClass]="[attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore) || utente.hasDelegheAttive
              ? 'btn-outline-primary'
              : 'btn-primary'">
            <i class="bi bi-table me-1"></i>
            Riepilogo modifiche
          </button>
          @if ([attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore) || utente.hasDelegheAttive) {
          <button type="button" (click)="approveItems()" class="btn btn-primary ms-3 fw-semibold"
            title="Approva selezionati" [disabled]="selectedData.length == 0">
            <i class="bi bi-check-lg me-1"></i>
            Approva selezionati
          </button>
          <button type="button" (click)="approveItems(true)" class="btn btn-primary ms-3 fw-semibold"
            title="Approva tutti" [disabled]="isApprovaTuttiDisabled()">
            <i class="bi bi-list-check me-1"></i>
            Approva tutti
          </button>
        }
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          @if (elencoRisorse.length > 0) {
          <app-tabella-elenco-risorse
            #tabellaElencoRisorseComponent
            [dataSource]="elencoRisorse"
            [elencoCount]="elencoCount"
            [attore]="attore"
            [hasSelection]="[attori.CFO, attori.DirettoreGenerale, attori.ResponsabilePrimoLivello].includes(attore) || !!utente.hasDelegheAttive"
            [selection]="selection"
            (selectionItemEvent)="masterSelection($event)"
            (iconItemEvent)="iconClick($event)"
            ></app-tabella-elenco-risorse>
          } @else {
          <p class="w-100 text-center">Nessuna risorsa presente</p>
          }
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
